module.exports = __webpack_public_path__ + "img/personnel-pay.c54c3d2d.png";